import { Flex, Text } from '@modusign/design-system';

type StepVariantType = 'active' | 'done' | 'todo';

interface StepProps {
  children: React.ReactNode;
  variant: StepVariantType;
}

const stepStyles: Record<
  StepVariantType,
  {
    backgroundColor: string;
    borderColor: string;
    color: string;
  }
> = {
  active: {
    backgroundColor: '#FFD600',
    borderColor: '#FFD600',
    color: 'textNeutralDark',
  },
  done: {
    backgroundColor: 'iconNeutralVeryLight',
    borderColor: 'iconNeutralVeryLight',
    color: 'textNeutralDark',
  },
  todo: {
    backgroundColor: 'transparent',
    borderColor: 'boxBorderNeutralLight',
    color: 'textNeutralVeryLight',
  },
};

export default function Step({ children, variant }: StepProps) {
  return (
    <Flex
      alignItems="center"
      backgroundColor={stepStyles[variant].backgroundColor}
      border="1px solid"
      borderColor={stepStyles[variant].borderColor}
      borderRadius="50%"
      height="21px"
      justifyContent="center"
      width="21px"
    >
      <Text color={stepStyles[variant].color} fontSize="10px" fontWeight="bold">
        {children}
      </Text>
    </Flex>
  );
}
